<template>
  <v-dialog v-model="productDialog" max-width="600" class="modern-dialog">
    <v-card class="customBorderRadius">
      <div class="dialog-header-green"></div>
      <v-card-title class="pb-2">
        <v-icon color="primary" class="mr-2">mdi-package-variant</v-icon>
        <span class="text-h6">Select Products</span>
      </v-card-title>
      <v-divider class="mx-4"></v-divider>

      <v-card-text class="pt-4">
        <!-- Product Grid -->
        <v-row v-if="productList.length > 0" class="ma-0">
          <v-col
            v-for="product in productList.filter((d) => !d.system)"
            :key="product.id"
            cols="12"
            sm="6"
            class="pa-2"
          >
            <v-card
              class="product-select-card customBorderRadius"
              :class="{ 'selected': productIds.includes(product.id) }"
              elevation="0"
              outlined
              @click="toggleProduct(product.id)"
            >
              <v-card-text class="pa-3">
                <div class="d-flex align-center">
                  <v-icon :color="product.hex" size="12" class="mr-2">
                    mdi-circle
                  </v-icon>
                  <h3 class="product-name flex-grow-1 text-truncate">
                    {{ product.title }}
                  </h3>
                  <v-checkbox
                    v-model="productIds"
                    :value="product.id"
                    dense
                    hide-details
                    color="primary"
                    class="mt-0 pt-0"
                    @click.stop
                  />
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <!-- Empty State -->
        <div v-else class="text-center py-8">
          <v-icon size="64" color="grey lighten-1">mdi-package-variant-closed</v-icon>
          <h5 class="text--secondary mt-3">No Products Available</h5>
        </div>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn
          text
          style="border-radius: 8px;"
          @click="closeDialog"
        >
          Cancel
        </v-btn>
        <v-btn
          color="primary"
          depressed
          style="border-radius: 8px;"
          @click="addProductInContact"
        >
          <v-icon left size="20">mdi-check</v-icon>
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  components: {},
  computed: {
    ...mapGetters([
      "ENDPOINT",
      "user",
      "dispoList",
      "fieldList",
      "teams",
      "selectedTeam",
      "selectedList",
    ]),
    companyDetails() {
      return this.$store.getters.companyDetails;
    },
  },
  data() {
    return {
      productDialog: false,
      loader: false,
      productList: [],
      productIds: [],
      contactSelected: "",
    };
  },
  async created() {
    var self = this;
    this.getProducts();
  },
  methods: {
    toggleProduct(productId) {
      const index = this.productIds.indexOf(productId);
      if (index > -1) {
        this.productIds.splice(index, 1);
      } else {
        this.productIds.push(productId);
      }
    },

    openDialog(item, products) {
      console.log("item", item);
      this.productIds = [];
      this.productDialog = true;
      if (products && products.length > 0) {
        this.productIds = _.map(products, "id");
      }

      this.contactSelected = item;
    },

    closeDialog() {
      this.productDialog = false;
    },

    addProductInContact() {
      console.log("Product Id", this.productIds);

      var postObj = {
        productsId: this.productIds,
        contactId: this.contactSelected.id,
      };

      this.$http
        .post(`${this.ENDPOINT}/products/set-product`, postObj)
        .then((response) => {
          console.log(response.body);

          this.closeDialog();
          this.$emit("updatedContact", this.contactSelected);
        });
    },
    async getProducts() {
      var self = this;
      var filter = {
        where: {
          companyId: this.$store.getters.user.companyId,
        },
      };

      try {
        var response = await this.$http.get(
          `${self.$store.state.ENDPOINT}/products?filter=${encodeURIComponent(
            JSON.stringify(filter)
          )}`
        );
        self.productList = response.body;

        self.loader = false;
      } catch (err) {
        console.log("Error", err);

        self.loader = false;

        self.$swal({
          type: "error",
          text: "Something went wrong. Please try again",
        });
      }
    },
  },
};
</script>

<style scoped>
.customBorderRadius {
  border-radius: 12px !important;
}

.dialog-header-green {
  height: 4px;
  background: linear-gradient(90deg, #37cf37 0%, #2ba82b 100%);
  border-radius: 12px 12px 0 0;
}

.product-select-card {
  transition: all 0.3s ease;
  cursor: pointer;
  border: 2px solid #e0e0e0;
}

.product-select-card:hover {
  border-color: #37cf37;
  box-shadow: 0 4px 12px rgba(55, 207, 55, 0.15);
}

.product-select-card.selected {
  border-color: #37cf37;
  background: rgba(55, 207, 55, 0.05);
}

.product-name {
  font-size: 15px;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.v-input__slot:before {
  border-color: rgb(0 0 0 / 2%) !important;
}
</style>
